export default __webpack_public_path__ + "static/media/vertical_bottom_to_top_right.f4ce9f2a.PNG";